import React from "react";
import { Modal, Button } from "react-bootstrap";

import "./DocumentUploadFileSizeErrorModal.css";

const DocumentUploadFileSizeErrorModal = ({
  open,
  handleClose,
  handleSubmit
}) => {

  return (
    <>
      <Modal show={open} onHide={handleClose} className="documentUploadFileSizeErr">
        <Modal.Header >
          <Modal.Title>File Size Limit</Modal.Title>
        </Modal.Header>
        <Modal.Body className="documentUploadFileSizeErr_modalBody">
        One or more of the files you are attempting to upload is greater than 50MB. Only files that are
         less than 50MB can be uploaded to VMS.
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-primary-md" onClick={handleSubmit}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentUploadFileSizeErrorModal;
